<div class="formFields mt-2" *ngIf="editFlag">
  <form action="" [formGroup]="createCustomFieldForm">
    <div class="field-section-group">
      <ng-template ngFor let-field [ngForOf]="customFieldsFormData['formFields']" let-i="index">
        <ng-template [ngIf]="field['fieldGroup'] === tabType && field.visible && (!field['assetType'] || (field['assetType'] && field['assetType'].includes(assetInfo.assetType)))">
          <div [ngSwitch]="field['fieldType']" class="field-box inline-block" [ngClass]="field['widthClass']">
            <div *ngSwitchCase="'text'" class="dataset-entry input-box">
              <span class="dataset-entry-label field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}{{ field['mandatory'] ? '*' : '' }}</span>
              <mat-form-field appearance="outline" color="primary" class="dataset-entry-value input-template template-name w-full">
                <input
                  autocomplete="off"
                  matInput
                  [disabled]="field['disabled']"
                  [type]="field['inputType']"
                  [name]="field['formFieldName']"
                  [formControlName]="field['formFieldName']"
                  [placeholder]="field['placeholder']"
                />
                <mat-error *ngIf="createCustomFieldForm.controls[field['formFieldName']].errors?.['required']">{{ field['fieldLabel'] + ' ' + textIsRequired }}</mat-error>
                <mat-error *ngIf="createCustomFieldForm.controls[field['formFieldName']].hasError('email')">Invalid {{ field['fieldLabel'] }}</mat-error>
              </mat-form-field>
            </div>
            <div *ngSwitchCase="'dropdown'" class="dataset-entry">
              <span class="dataset-entry-label field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}{{ field['mandatory'] ? '*' : '' }}</span>
              <sp-mat-select-search
                class="dataset-entry-value w-full"
                [formControlName]="field['formFieldName']"
                [dataSource]="field['options']"
                [placeholder]="field['placeholder']"
                [config]="{ search: true, multiple: field['multiple'], enableSecondPartLabel: true, required: field['mandatory'], requiredText: field['fieldLabel'] + ' ' + textIsRequired }"
                [attrDataTestId]="'custom-asset-fields_' + field['formFieldName']"
                (selectedChange)="onValueChange(field['formFieldName'])"
              ></sp-mat-select-search>
            </div>
            <div *ngSwitchCase="'textarea'" class="dataset-entry input-box">
              <div class="dataset-entry-label field-label flex flex-row justify-between">
                <span class="font-bold" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}{{ field['mandatory'] ? '*' : '' }}</span>
              </div>
              <div class="dataset-entry-value">
                <sp-editor
                  [formControlName]="field['formFieldName']"
                  [placeholder]="field['placeholder']"
                  [maxLength]="5000"
                  [taggingOptions]="taggingOptions"
                  (usersList)="taggedUserList($event)"
                  (descriptionText)="editorDescriptionText($event)"
                ></sp-editor>
                <mat-error
                  class="px-4 text-xs text-red-600"
                  *ngIf="createCustomFieldForm.controls[field['formFieldName']].errors?.['required'] && createCustomFieldForm.controls[field['formFieldName']].touched"
                  i18n
                >
                  Description is required
                </mat-error>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </form>
</div>
<div class="formFields" *ngIf="!editFlag">
  <div class="field-section-group">
    <ng-template ngFor let-field [ngForOf]="customFieldsFormData['formFields']" let-i="index">
      <ng-template
        [ngIf]="
          field['fieldGroup'] === tabType &&
          !field.hideDetailsView &&
          (!field['assetType'] || (field['assetType'] && field['assetType'].includes(assetInfo.assetType))) &&
          (((assetInfo[field['formFieldName']] || field['formFieldName'] === 'expiryDate') && brandingKey === CustomClients.VKB) ||
            (assetInfo.customFields && assetInfo.customFields[field['formFieldName']] && assetInfo.customFields[field['formFieldName']] !== ''))
        "
      >
        <div [ngSwitch]="field['fieldType']" class="field-box inline-block" [ngClass]="field['widthClass']">
          <div *ngSwitchCase="'dropdown'" class="input-box">
            <div class="dataset-entry flex row items-start mb-2">
              <span class="dataset-entry-label w-2/5 field-label" [ngClass]="applyMaxLabelCSSStyle"
                >{{ field['fieldLabel'] }}
                <sup class="text-[#1212128F] cursor-pointer" *ngIf="field['userInfotext'] || field['infotext']"
                  ><mat-icon [matTooltip]="field['userInfotext'] ?? field['infotext']" matTooltipClass="tooltip-list" class="!overflow-clip text-xs">info</mat-icon></sup
                ></span
              >
              <div class="dataset-entry-value inline-block w-3/5 pl-2">
                <span>{{ assetInfo.customFields?.[field['formFieldName']] | optionsLabel: field['options'] }}&#160;</span>
                <ng-container *ngIf="assetInfo.customFields?.[field['formFieldName']] | optionsTooltip: field.options as tooltip">
                  <sup *ngIf="tooltip?.trim()" class="text-[#1212128F] cursor-pointer">
                    <mat-icon [matTooltip]="tooltip" matTooltipClass="tooltip-list" class="!overflow-clip text-xs">info</mat-icon>
                  </sup>
                </ng-container>
              </div>
            </div>
          </div>
          <div *ngSwitchCase="'date'" class="input-box">
            <div class="dataset-entry flex row items-start mb-2">
              <span class="dataset-entry-label w-2/5 field-label inline-block truncate" [ngClass]="applyMaxLabelCSSStyle"
                >{{ field['fieldLabel'] }}
                <sup class="text-[#1212128F] cursor-pointer" *ngIf="field['userInfotext'] || field['infotext']"
                  ><mat-icon [matTooltip]="field['userInfotext'] ?? field['infotext']" matTooltipClass="tooltip-list" class="!overflow-clip text-xs">info</mat-icon></sup
                ></span
              >
              <div class="dataset-entry-value inline-block w-3/5 pl-2 break-words align-top truncate">
                <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]" *ngIf="assetInfo[field['formFieldName']]">
                  <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="assetInfo[field['formFieldName']] | spDateFormat: { plainDate: true, isSafe: true }"></div>
                </div>
                <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]" *ngIf="field['formFieldName'] === 'expiryDate' && !assetInfo[field['formFieldName']]">
                  <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" i18n>Kein Ablaufdatum</div>
                </div>
                <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]" *ngIf="assetInfo.customFields?.[field['formFieldName']]">
                  <div
                    class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden"
                    [innerHTML]="assetInfo.customFields?.[field['formFieldName']] | spDateFormat: { plainDate: true, isSafe: true }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div *ngSwitchDefault class="input-box">
            <div class="dataset-entry flex row items-start mb-2">
              <span class="dataset-entry-label w-2/5 field-label inline-block truncate" [ngClass]="applyMaxLabelCSSStyle"
                >{{ field['fieldLabel'] }}
                <sup class="text-[#1212128F] cursor-pointer" *ngIf="field['userInfotext'] || field['infotext']"
                  ><mat-icon [matTooltip]="field['userInfotext'] ?? field['infotext']" matTooltipClass="tooltip-list" class="!overflow-clip text-xs">info</mat-icon></sup
                ></span
              >
              <div class="dataset-entry-value inline-block w-3/5 pl-2 break-words align-top truncate">
                <div class="ql-container ql-snow !bg-inherit !border-0 !min-h-[inherit]">
                  <ng-template [ngIf]="field['formFieldName'] === 'exchange_link'" [ngIfElse]="empty">
                    <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden">
                      <a href="{{ assetInfo.customFields?.[field['formFieldName']] }}" target="_blank">{{ assetInfo.customFields?.[field['formFieldName']] }}</a>
                    </div>
                  </ng-template>
                  <ng-template #empty>
                    <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="assetInfo.customFields?.[field['formFieldName']]"></div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
